import React from 'react';
export function OpeningHook() {
  return <section className="bg-navy-900 py-20 px-4 sm:px-6 lg:px-8" data-id="element-111">
      <div className="max-w-3xl mx-auto space-y-8 text-center" data-id="element-112">
        <p className="text-xl sm:text-2xl text-[#e0e0e0] italic font-playfair leading-relaxed" data-id="element-113">
          "Son las 7:00 PM. Acabas de llegar a casa después de un día agotador
          de decisiones y estrés. Miras a tu pareja, miras a tus hijos, y lo
          único que sientes es que tu tanque está completamente vacío. Querrías
          estar presente, querrías tener esa chispa de energía que te hacía
          imparable hace 15 años, pero la realidad es que solo quieres
          desplomarte en el sofá."
        </p>
        <div className="w-24 h-1 bg-gold-500 mx-auto rounded-full" data-id="element-114"></div>
        <p className="text-lg text-[#e0e0e0] leading-relaxed" data-id="element-115">
          No es falta de voluntad. Es un apagón hormonal silencioso que afecta
          al hombre moderno después de los 40. Tu cuerpo ha dejado de producir
          el combustible que alimenta tu confianza y tu virilidad.
        </p>
      </div>
    </section>;
}